import StorageSvc from '../services/StorageSvc';

export const UK_PRIVATE_COMPANY_TOP_YEAR_FILTERS = 'UK_PRIVATE_COMPANY_TOP_YEAR_FILTERS';
export const UK_PRIVATE_COMPANY_INVESTORS_FILTERS = 'UK_PRIVATE_COMPANY_INVESTORS_FILTERS';
export const UK_PRIVATE_COMPANY_SINGLE_INVESTORS_FILTERS = 'UK_PRIVATE_COMPANY_SINGLE_INVESTORS_FILTERS';
export const UK_PRIVATE_COMPANY_FUNDRAISING_FILTERS = 'UK_PRIVATE_COMPANY_FUNDRAISING_FILTERS';
export const UK_PRIVATE_COMPANY_SINGLE_FUNDRAISING_FILTERS = 'UK_PRIVATE_COMPANY_SINGLE_FUNDRAISING_FILTERS';
export const UK_PRIVATE_COMPANY_MARKET_FILTERS = 'UK_PRIVATE_COMPANY_MARKET_FILTERS';
export const UK_PRIVATE_COMPANY_ROI_FILTERS = 'UK_PRIVATE_COMPANY_ROI_FILTERS';
export const UK_PRIVATE_COMPANY_HIDE_ABNORMAL = 'UK_PRIVATE_COMPANY_HIDE_ABNORMAL';
export const UK_PRIVATE_COMPANY_STATUS_ALL_COMPANIES_FILTERS = 'UK_PRIVATE_COMPANY_STATUS_ALL_COMPANIES_FILTERS';
export const UK_PRIVATE_COMPANY_CHANGES_COMPANIES_STATUS_FILTERS = 'UK_PRIVATE_COMPANY_CHANGES_COMPANIES_STATUS_FILTERS';

export const setUKTopYearFilters = (payload) => ({
  type: UK_PRIVATE_COMPANY_TOP_YEAR_FILTERS,
  payload,
});

export const handleInvestorsFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_INVESTORS_FILTERS,
  payload,
});

export const handleSingleInvestorsFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_SINGLE_INVESTORS_FILTERS,
  payload,
});

export const handleFundraisingFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_FUNDRAISING_FILTERS,
  payload,
});

export const handleSingleFundraisingFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_SINGLE_FUNDRAISING_FILTERS,
  payload,
});

export const handleMarketFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_MARKET_FILTERS,
  payload,
});

export const handleRoiFilter = (payload) => ({
  type: UK_PRIVATE_COMPANY_ROI_FILTERS,
  payload,
});

export const setUKPrivateCompanyHideAbnormal = (payload) => ({
  type: UK_PRIVATE_COMPANY_HIDE_ABNORMAL,
  payload,
});

export const handleStatusAllCompaniesFilter = (payload) => (dispatch) => {
  StorageSvc.setItem('statusAllCompaniesFilter', JSON.stringify(payload));
  dispatch({
    type: UK_PRIVATE_COMPANY_STATUS_ALL_COMPANIES_FILTERS,
    payload,
  });
};

export const handleChangesCompaniesStatusFilter = (payload) => (dispatch) => {
  StorageSvc.setItem('changesCompaniesStatusFilter', JSON.stringify(payload));
  dispatch({
    type: UK_PRIVATE_COMPANY_CHANGES_COMPANIES_STATUS_FILTERS,
    payload,
  });
};
